<template>
  <el-card
    style="height:99%;"
    :body-style="{height: '100%' }"
    class="bikes-map mead-bike-map"
  >
    <template #header>
      <content-header />
    </template>
    <!-- <el-button-group class="mb-3">
      <el-button @click="() => $refs.searchForm.toggleShow()">筛选</el-button>
    </el-button-group> -->

    <!-- <search-form ref="searchForm" style="margin-left:5px" :fields="search"/> -->
    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <el-button
          type="success"
          @click="superSearchDialogVisible=true"
        >
          <slot>高级搜索</slot>
        </el-button>
        <!-- <el-button type="primary" @click="addAdvertisement">添加广告</el-button> -->
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :visible.sync="superSearchDialogVisible"
      width="30%"
    >
      <el-form
        ref="superForm"
        :model="superForm"
        :rules="superFormRules"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item
          required
          prop="bike_no"
          label="车辆编号"
        >
          <el-input
            v-model="superForm.bike_no"
            style="width:350px;"
          />
        </el-form-item>
        <el-form-item
          required
          prop="time_between"
          label="日期区间"
        >
          <el-date-picker
            v-model="superForm.time_between"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="superSearchDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="superSearch('superForm')"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-row
      class="el-row-big"
      style="height: 95%;"
    >
      <div class="amap-page-container">
        <el-amap-search-box
          class="search-box"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
        />
        <el-amap
          vid="amap"
          :plugin="plugin"
          class="amap-demo"
          :center="center"
          :default-cursor="defaultCursor"
          :zoom="zoom"
          :amap-manager="amapManager"
          :events="events"
        >
          <el-amap-circle
            v-for="(circle,index) in circles"
            :key="'info2-'+index"
            :center="circle.center"
            :radius="circle.radius"
            :fill-opacity="circle.fillOpacity"
            :stroke-opacity="circle.strokeOpacity"
            :events="circle.events"
          />
          <el-amap-polygon
            v-for="(polygon, index) in polygons"
            :key="`parking_${index}`"
            :vid="index"
            :editable="false"
            :ref="`polygon_${index}`"
            :path="polygon.path"
            :z-index="40"
            :draggable="polygon.draggable"
            :fill-opacity="polygon.fillOpacity"
            :events="polygon.events"
          />
          <el-amap-polygon
            v-for="(polygon, index) in banPolygons"
            :key="`parkingb_${index}`"
            :vid="index"
            :editable="false"
            :ref="`polygonb_${index}`"
            :path="polygon.path"
            :z-index="40"
            :draggable="polygon.draggable"
            :fill-opacity="polygon.fillOpacity"
            :fill-color="polygon.fillColor"
            :stroke-color="polygon.strokeColor"
            :events="polygon.events"
          />
          <el-amap-polygon
            v-for="(polygon, index) in polygonsarea"
            :key="'infopolygonsarea2'+index"
            :vid="index"
            :ref="`polygon_${index}`"
            :path="polygon.path"
            :z-index="polygon.zIndex"
            :fill-opacity="polygon.fillOpacity"
            :draggable="polygon.draggable"
            :events="polygon.events"
          />
          <el-amap-info-window
            v-if="window"
            :position="window.position"
            :visible="window.visible"
            :template="window.template"
          />

          <div class="map-edit-container">
            <div class="map-edit-item">
              <div>
                <img
                  src="@/assets/bikesInfo/low.29a1bda.png"
                  alt="低电量"
                >
              </div>
              <div>
                <span class="span-cs">低电量</span>
                <span class="color-span">{{ low_power_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img
                  src="@/assets/bikesInfo/using.172bef6.png"
                  alt="使用中"
                >
              </div>
              <div>
                <span class="span-cs">使用中</span>
                <span class="color-span">{{ riding_yes_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img
                  src="@/assets/bikesInfo/unuse.38fefdf.png"
                  alt="未使用"
                >
              </div>
              <div>
                <span class="span-cs">未使用</span>
                <span class="color-span">{{ riding_no_num }}</span>
              </div>
            </div>
            <div class="map-edit-item">
              <div>
                <img
                  src="http://resource.bike.hanyiyun.com/work_riding.png"
                  alt="运维使用"
                >
              </div>
              <div>
                <span class="span-cs">运维用</span>
                <span class="color-span">{{ worker_riding_num }}</span>
              </div>
            </div>
          </div>
        </el-amap>
      </div>
      <div class="infos">
        <div
          v-for="(row, key) in bikes"
          :key="key"
          class="info-list"
        >
          <div
            @click="rowClick(key,row)"
            style="width:100%;"
          >
            <el-card
              class="item-row order-trajectory"
              :class="{'gary':(row.id === click_index)}"
            >
              <div class="item-info">
                <i class="el-icon-bicycle" />
                <span>{{ row.bike_no }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-cpu" />
                <span>{{ row.box_no }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-more-outline" />
                <span>剩余{{ row.battery_power }}% 电量</span>
              </div>
              <div class="item-info">
                <i class="el-icon-alarm-clock" />
                <span>{{ row.last_location_time }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-row>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import Pagination from "@c/Pagination";
import SearchForm from "@c/SearchForm";
import { getAreas, showArea } from "@/api/area";
import { getParkings } from "@/api/parking";
import {
  getBikes,
  getBikeStatistics,
  getBikePosition,
  getMapBikes,
  bikeStatusValueLabel,
  getTrajectorys
} from "@/api/bike";
import VueAMap from "vue-amap";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "BikeDistributionMap",
  components: {
    Pagination,
    SearchForm
  },
  data() {
    let self = this;
    let amapManager = new VueAMap.AMapManager();
    return {
      click_index: undefined,
      put_areas: [
        {
          id: "",
          name: "全部"
        }
      ],
      search: [
        {
          field: "bike_no",
          label: "车牌号"
        },
        {
          field: "box_no",
          label: "控制设备编号"
        },
        {
          type: "el-select",
          field: "is_low_battery_power",
          label: "电量状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "1",
              label: "正常"
            },
            {
              value: "0",
              label: "低电量"
            }
          ]
        },
        {
          type: "el-select",
          field: "all_states",
          label: "骑行状态",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "last_use_bike_end_time",
          label: "未骑行时间",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1, // this.getNowFormatDate(1),
              label: "一天以上"
            },
            {
              value: 3, // this.getNowFormatDate(3),
              label: "三天以上"
            },
            {
              value: 5, // this.getNowFormatDate(5),
              label: "五天以上"
            },
            {
              value: 7, // this.getNowFormatDate(7),
              label: "七天以上"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_status",
          label: "是否投放",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "已投放"
            },
            {
              value: 0,
              label: "未投放"
            }
          ]
        }
      ],
      riding_yes_num: "",
      riding_no_num: "",
      low_power_num: "",
      worker_riding_num: "",
      searchOption: {
        city: "郑州",
        citylimit: false
      },
      page: null,
      areas: [],
      area: "",
      bikes: [],
      is_low_battery_power: "",
      windows: [],
      window: "",
      bike_position_name: "未知",

      is_riding: "",

      last_use_bike_end_time: "",

      searchs: "",
      circles: [],
      polygons: [],
      banPolygons: [],
      polygonsarea: [
        // 运营骑行区域
        {
          draggable: false,
          path: [],
          fillOpacity: 0.1,
          zIndex: 30,
          events: {
            click: () => {
              // alert('click polygon')
              // console.log(amapManager.getComponent(0))
              // console.log(this.$refs.map.$$getCenter())
              // console.log(this.$refs.polygon_0[0].$$getPath())
            }
          }
        }
      ],
      // marker: {
      //   position: [113.73350255780726, 34.78024666564106],
      //   events: {
      //     click: (e) => {
      //       let key = e.target.get('vid')
      //       this.rowClick(key)
      //     },
      //   },
      //   visible: true,
      //   draggable: false,
      // },
      // content1: '<img src=' + '/admin-dev/img/using.172bef6.172bef66.png' + '>',
      // content2: '<img src=' + '/admin-dev/img/low.29a1bda.29a1bdac.png' + '>',
      // content3: '<img src=' + '/admin-dev/img/unuse.38fefdf.38fefdf9.png' + '>',
      icon2: "http://resource.bike.hanyiyun.com/common/low-power.admin.png",
      icon1: "http://resource.bike.hanyiyun.com/common/using.admin.png",
      icon3: "http://resource.bike.hanyiyun.com/common/unuse.admin.png",
      center: [121.59996, 31.197646],
      defaultCursor: "pointer",
      zoom: 12,
      lng: 0,
      lat: 0,
      loaded: false,
      points: [],
      amapManager: amapManager,
      events: {
        init(o) {}
      },
      mouseTool: null,
      plugin: [
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            init(o) {
              // console.log(o)
            }
          }
        },
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                // console.log(11)
                self.lng = 113.73350255780726;
                self.lat = 34.78024666564106;
                self.center = [self.lng, self.lat];
                self.loaded = true;
                if (result && result.position) {
                  // console.log(result.position)
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            }
          }
        },
        {
          pName: "Scale",
          // offset: { x: 1, y: 1 },
          position: "RB",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      first_blood: true,
      oldMsaaMarks: "",
      superSearchDialogVisible: false,
      superForm: {
        bike_no: "",
        time_between: ""
      },
      superFormRules: {
        bike_no: [
          { required: true, message: "请输入车辆编号", trigger: "blur" }
        ],
        time_between: [
          { required: true, message: "请选择时间区间", trigger: "change" }
        ]
      },
      pathData: [],
      pathDataTimes: [],
      pathDataRoles: [],
      pathMarks: []
    };
  },
  async created() {
    const [{ data: areas }, { data: statistics }] = await Promise.all([
      getAreas({ all: 1 }),
      getBikeStatistics()
    ]);

    this.areas = areas;
    this.put_areas.push.apply(this.put_areas, areas);
    this.search[5].options.push.apply(this.search[5].options, areas);

    this.low_power_num = statistics.low_power_num;
    this.riding_yes_num = statistics.riding_yes_num;
    this.riding_no_num = statistics.riding_no_num;
    this.worker_riding_num = statistics.worker_riding_num;
    const { data: bikeStatus } = await bikeStatusValueLabel();
    this.search[3].options.push.apply(this.search[3].options, bikeStatus);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[7].options.push.apply(
          this.search[7].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    superSearch(form) {
      var _this = this;
      _this.clickIn = "";
      // console.log(this.superForm)
      this.$refs[form].validate(valid => {
        if (valid) {
          // alert('submit!')
          getTrajectorys(this.superForm).then(res => {
            res.then(data => {
              // console.log(data.data)
              if (window.pathSimplifierIns) {
                // console.log(pathSimplifierIns)
                // 去除轨迹
                pathSimplifierIns.setData([]);
                // pathSimplifierIns.destroy()

                // 去除巡航器
                pathSimplifierIns.clearPathNavigators();
              }

              this.orders = [];
              this.pathMarks = [];
              this.pathData = data.data.locations;
              this.pathDataTimes = data.data.locations_time;
              this.pathDataRoles = data.data.locations_role;
              this.pathMarks = data.data.marks;
              this.superSearchDialogVisible = false;
              // this.startMark.position = [0, 0]
              // this.endMark.position = [0, 0]
              if (data.data.length === 0) {
                // this.startMark.position = [0, 0]
                // this.endMark.position = [0, 0]
                this.pathMarks = [];
                this.$message("暂无记录");
                // console.log(111)
                return;
              }
              this.orders = data.data.orders;

              AMapUI.load(["ui/misc/PathSimplifier"], function(PathSimplifier) {
                if (!PathSimplifier.supportCanvas) {
                  alert("当前环境不支持 Canvas！");
                  return;
                }

                // 启动页面
                _this.initPage(PathSimplifier);
              });
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initPage(PathSimplifier) {
      let _this = this;
      // 创建组件实例
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: this.amapManager._map, // 所属的地图实例
        getPath: function(pathData, pathIndex) {
          // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path;
        },
        getHoverTitle: function(pathData, pathIndex, pointIndex) {
          // console.log(_this.pathDataTimes)
          // 返回鼠标悬停时显示的信息
          if (pointIndex >= 0) {
            // 鼠标悬停在某个轨迹节点上
            return (
              "点:" +
              pointIndex +
              "/" +
              pathData.path.length +
              ",时间:" +
              _this.pathDataTimes[pointIndex] +
              ",角色:" +
              _this.pathDataRoles[pointIndex]
            );
          }
          // 鼠标悬停在节点之间的连线上
          return pathData.name + "，点数量" + pathData.path.length;
        },
        renderOptions: {
          // 轨迹线的样式
          pathLineStyle: {
            strokeStyle: "red",
            lineWidth: 2,
            dirArrowStyle: true
          },
          renderAllPointsIfNumberBelow: 1000
        }
      });
      pathSimplifierIns.renderLater([{ delay: 1000 }]);
      window.pathSimplifierIns = pathSimplifierIns;

      // 这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: "轨迹",
          path: this.pathData
        }
      ]);

      // 创建一个巡航器
      var navg0 = pathSimplifierIns.createPathNavigator(
        0, // 关联第1条轨迹
        {
          loop: true, // 循环播放
          speed: 500
        }
      );

      navg0.start();
      // 清除老数据 清除地图车辆海量点
      if (_this.oldMsaaMarks !== "") {
        _this.oldMsaaMarks.clear();
      }
      _this.closeInfoWindow();
    },
    onSearchResult(pois) {
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        pois.forEach(poi => {
          let { lng, lat } = poi;
          lngSum += lng;
          latSum += lat;
          // this.markers.push([poi.lng, poi.lat])
        });
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        };
        this.center = [center.lng, center.lat];
      }
    },
    handle({ BMap, map }) {
      // var times = this.getNowFormatDate()
      // 初始化定位
      let _this = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          _this.center = { lng: r.longitude, lat: r.latitude };
        },
        { enableHighAccuracy: true }
      );
    },

    async rowClick(key, row) {
      // 点击侧边列

      this.click_index = row.id;

      // 需要异步 否则渲染失败
      // eslint-disable-next-line camelcase
      let start_use_bike_time = "";
      const { data } = await getBikePosition({ bike_id: row.id });
      this.bike_position_name = data.position;
      start_use_bike_time = data.lately_order.start_use_bike_time
        ? data.lately_order.start_use_bike_time
        : "暂无";
      let user_name = data.lately_order.username
        ? data.lately_order.username
        : "暂无";
      let user_phone = data.lately_order.mobile
        ? data.lately_order.mobile
        : "暂无";
      var class_no = "list-item";
      var work_name = "";
      var work_phone = "";
      if (data.workInfo.length == 0) {
        class_no = "list-no-show";
        console.log(111);
      } else {
        console.log(222);
        class_no = "list-show";
        var work_name = data.workInfo.name;
        var work_phone = data.workInfo.phone;
      }
      // getBikePosition({ bike_id: row.id }).then(res => {
      //   res.then(data => {
      //     this.bike_position_name = data.data.position
      //   })
      // })

      this.center = [row.last_location.lng, row.last_location.lat];
      this.zoom = 15;
      var infoWindow = new AMap.InfoWindow({
        // isCustom: true,
        draggable: false, // 是否可拖动
        autoMove: true,
        // offset: new VueAMap.Pixel(0, -31),
        content:
          `<div style="width:480px; background:#fff;">
                    <div class="title">车辆信息</div>
                     <p class="list-item">车牌号：<span>` +
          row.bike_no +
          `</span></p>
                     <p class="list-item">设备号：<span>` +
          row.box_no +
          `</span></p>
                     <p class="list-item">状态：<span>` +
          (row.is_trouble ? "有故障" : "无故障") +
          `</span></p>
                     <p class="list-item">电量：<span>` +
          row.battery_power +
          `%</span></p>
                     <p class="list-item">最新定位时间：<span>` +
          row.last_location_time +
          `</span></p>
                     <p class="list-item">最近订单时间：<span>` +
          start_use_bike_time +
          `</span></p>
                     <p class="list-item">最近用户名：<span>` +
          user_name +
          `</span></p>
                     <p class="list-item">最近用户手机：<span>` +
          user_phone +
          `</span></p>
                     <p class="list-item ` +
          class_no +
          `">运维人员：<span>` +
          work_name +
          `</span></p>
                     <p class="list-item ` +
          class_no +
          `">运维人员手机：<span>` +
          work_phone +
          `</span></p>
                     <p class="list-item"><span>最新定位位置：</span><span>` +
          this.bike_position_name +
          `</span></p>
                     </div>
                     `
      });
      infoWindow.open(
        this.amapManager._map,
        new AMap.LngLat(row.last_location.lng, row.last_location.lat)
      );
    },
    closeInfoWindow() {
      this.amapManager._map.clearInfoWindow();
    },
    getAddress(pointAdd) {},
    async pointClick(id) {
      // 点击地图
      // 需要异步 否则渲染失败
      let start_use_bike_time = "";
      this.click_index = id;
      const { data } = await getBikePosition({ bike_id: id });
      this.bike_position_name = data.position;
      // getBikePosition({ bike_id: row.id }).then(res => {
      //   res.then(data => {
      //     this.bike_position_name = data.data.position
      //   })
      // })
      start_use_bike_time = data.lately_order.start_use_bike_time
        ? data.lately_order.start_use_bike_time
        : "暂无";
      let user_name = data.lately_order.username
        ? data.lately_order.username
        : "暂无";
      let user_phone = data.lately_order.mobile
        ? data.lately_order.mobile
        : "暂无";

      let row = data.bike;

      var class_no = "list-item";
      var work_name = "";
      var work_phone = "";
      if (data.workInfo.length == 0) {
        class_no = "list-no-show";
        console.log(111);
      } else {
        console.log(222);
        class_no = "list-show";
        var work_name = data.workInfo.name;
        var work_phone = data.workInfo.phone;
      }

      this.center = [row.last_location.lng, row.last_location.lat];
      this.zoom = 15;
      var infoWindow = new AMap.InfoWindow({
        // isCustom: true,
        draggable: false, // 是否可拖动
        autoMove: true,
        // offset: new VueAMap.Pixel(0, -31),
        content:
          `<div style="width:480px; background:#fff;">
                    <div class="title">车辆信息</div>
                     <p class="list-item">车牌号：<span>` +
          row.bike_no +
          `</span></p>
                     <p class="list-item">设备号：<span>` +
          row.box_no +
          `</span></p>
                     <p class="list-item">状态：<span>` +
          (row.is_trouble ? "有故障" : "无故障") +
          `</span></p>
                     <p class="list-item">电量：<span>` +
          row.battery_power +
          `%</span></p>
                     <p class="list-item">最新定位时间：<span>` +
          row.last_location_time +
          `</span></p>
                     <p class="list-item">最近订单时间：<span>` +
          start_use_bike_time +
          `</span></p>
                     <p class="list-item">最近用户名：<span>` +
          user_name +
          `</span></p>
                     <p class="list-item">最近用户手机：<span>` +
          user_phone +
          `</span></p>
                     <p class="list-item ` +
          class_no +
          `">运维人员：<span>` +
          work_name +
          `</span></p>
                     <p class="list-item ` +
          class_no +
          `">运维人员手机：<span>` +
          work_phone +
          `</span></p>
                     <p class="list-item"><span>最新定位位置：</span><span>` +
          this.bike_position_name +
          `</span></p>
                     </div>
                     `
      });
      infoWindow.open(
        this.amapManager._map,
        new AMap.LngLat(row.last_location.lng, row.last_location.lat)
      );
    },
    getNowFormatDate(days = 0) {
      // 获取当前时间
      var date = new Date();
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * days);
      var seperator1 = "-";
      var seperator2 = ":";
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      var res = new Date(currentdate).getTime() / 1000;
      return currentdate; // parseInt(res)
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        newVal.query.all = 1;
        if (this.first_blood) {
          newVal.query.put_status = "1";
          this.first_blood = false;
        }
        const {
          // data: { data, meta },
          data
        } = await getBikes(newVal.query);
        const { data: statistics } = await getBikeStatistics(newVal.query);
        this.low_power_num = statistics.low_power_num;
        this.riding_yes_num = statistics.riding_yes_num;
        this.riding_no_num = statistics.riding_no_num;
        this.worker_riding_num = statistics.worker_riding_num;
        this.bikes = data;
        //
        let _this = this;
        const { data: bikesMap } = await getMapBikes(newVal.query);
        // 创建样式对象
        var styleObjectArr = [
          {
            url: "http://resource.bike.hanyiyun.com/common/low-power.admin.png", // 图标地址 低电量
            size: new AMap.Size(25, 35), // 图标大小
            anchor: new AMap.Pixel(5, 5) // 图标显示位置偏移量，基准点为图标左上角
          },
          {
            url: "http://resource.bike.hanyiyun.com/common/unuse.admin.png", // 图标地址  未使用
            size: new AMap.Size(25, 35), // 图标大小
            anchor: new AMap.Pixel(5, 5) // 图标显示位置偏移量，基准点为图标左上角
          },
          {
            url: "http://resource.bike.hanyiyun.com/common/using.admin.png", // 图标地址  使用中
            size: new AMap.Size(25, 35), // 图标大小
            anchor: new AMap.Pixel(5, 5) // 图标显示位置偏移量，基准点为图标左上角
          },
          {
            url: "http://resource.bike.hanyiyun.com/work_riding.png", // 图标地址  运维使用中
            size: new AMap.Size(25, 35), // 图标大小
            anchor: new AMap.Pixel(5, 5) // 图标显示位置偏移量，基准点为图标左上角
          },
          {
            url: "http://resource.bike.hanyiyun.com/bike_yunwei/outLi.png", // 图标地址  离线
            size: new AMap.Size(30, 35), // 图标大小
            anchor: new AMap.Pixel(5, 5) // 图标显示位置偏移量，基准点为图标左上角
          }
        ];
        // 清除老数据
        if (_this.oldMsaaMarks !== "") {
          _this.oldMsaaMarks.clear();
        }

        var massMarks = new AMap.MassMarks(bikesMap, {
          zIndex: 500, // 海量点图层叠加的顺序
          zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
          style: styleObjectArr // 设置样式对象
        });

        massMarks.on("mousedown", function(e) {
          _this.pointClick(e.data.id);
        });
        massMarks.setMap(this.amapManager._map);
        _this.oldMsaaMarks = massMarks;

        //

        var areaId = this.bikes[0].put_area_id;
        if (newVal.query.put_area_id !== undefined) {
          areaId = newVal.query.put_area_id;
        }
        if (areaId !== undefined) {
          // 骑行区域
          const [{ data: darea }] = await Promise.all([showArea(areaId)]);
          var is_parking_fushe = darea.areaSetting.is_parking_fushe;
          this.polygonsarea[0].path = JSON.parse(darea.area_fence);
          this.center = JSON.parse(darea.area_centre);
          // 取出此区域的停车区
          const [{ data }] = await Promise.all([
            getParkings({ type: 2, area_id: areaId, status: 1 })
          ]);
          let polygons = [];
          let circles = [];
          var datas = data; // 所有停车区遍历显示
          datas.forEach((item, i) => {
            item.parking_centre = JSON.parse(item.parking_centre);

            polygons.push({
              draggable: false,
              strokeOpacity: 0.1,
              fillOpacity: 0.1,
              path: item.parking_fence,
              events: {
                change: () => {},
                click: () => {}
              }
            });

            circles.push({
              center: item.parking_centre,
              radius: item.parking_radius,
              fillOpacity: 0.1,
              events: {
                click: () => {
                  // alert('click')
                }
              }
            });
          });
          if (is_parking_fushe == 1) {
            this.circles = circles;
          }
          this.polygons = polygons;

          // 取出此区域的禁停区
          const [{ data: banData }] = await Promise.all([
            getParkings({ type: 1, area_id: areaId, status: 1 })
          ]);
          let banPolygons = [];
          // var banData = banData // 所有停车区遍历显示
          banData.forEach((item, i) => {
            item.parking_centre = JSON.parse(item.parking_centre);

            banPolygons.push({
              draggable: false,
              strokeOpacity: 0.1,
              fillOpacity: 0.3,
              fillColor: "red",
              strokeColor: "red",
              path: item.parking_fence,
              events: {
                change: () => {},
                click: () => {}
              }
            });

            // circles.push({
            //   center: item.parking_centre,
            //   radius: item.parking_radius,
            //   fillOpacity: 0.1,
            //   events: {
            //     click: () => {
            //       // alert('click')
            //     },
            //   },
            // },)
          });
          this.banPolygons = banPolygons;
        } else {
          const [{ dataP }] = await Promise.all([getParkings({ type: 2 })]);

          this.circles = [];
          this.polygons = [];
          this.banPolygons = [];
          // 骑行区域
          this.polygonsarea[0].path = [];
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.gary {
  background-color: #aaa;
}
.bikes-map {
  .el-card__body {
    height: 92% !important;
    margin-top: 0;
    .el-row-big {
      display: flex;
      justify-content: space-between;
      height: calc(100% - 50px) !important;
      .infos {
        // height: 700px;
        // height: 85%;
        width: 15%;
        cursor: pointer;
        overflow: auto;
      }
      .amap-page-container {
        width: 84%;
        .map-edit-container {
          margin: 0;
          border-radius: 0.25rem;
          position: absolute;
          top: 20px;
          width: 300px;
          justify-content: space-between;
          /* min-width: 2rem; */
          border-width: 0px;
          right: 26%;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          background: white;
          // border:1px solid #000;

          .map-edit-item {
            padding: 5px 10px 2px 5px;
            display: -webkit-box;
            // display: flex;
            justify-content: space-between;
            align-items: center;
            div:last-child {
              padding: 2px 4px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .span-cs {
                margin-top: -7px;
              }

              .color-span {
                color: blue;
              }
            }
            span {
              font-size: 7px;
            }
          }
        }
      }
      .filters {
        margin: 10px;
        .selectwidth {
          width: 100px;
          margin-right: 15px;
        }
        .searchs {
          width: 200px;
          margin-right: 15px;
        }
      }

      .search-box {
        height: 36px;
        border-radius: 0.25rem;
        border-width: 1px;
        left: 90px;
        position: absolute !important;
        top: 20px;
      }

      //     .amap-icon img {
      //     width: 24px;
      // }

      .el-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .info-list {
        width: 100%;
        flex-direction: row-reverse;
        display: flex;
        background-color: hsla(0, 0%, 100%, 0.9);
        font-size: 14px;
        line-height: 1.15;
        .item-info {
          padding: 2.5px 0;
          span {
            margin: 5px;
          }
        }
      }

      .points-coll {
        background-image: "@/assets/bikesInfo/low.29a1bda.png";
      }
    }
  }
}
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
<style>
.list-show {
  color: red;
}
.list-no-show {
  display: none;
}
</style>
